import { render } from "./History.vue?vue&type=template&id=7d84103a&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=7d84103a&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Vue\\NK\\Register_studen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d84103a"]])

export default __exports__